import { httpClient } from '../../services/http-client'
import { JoinOrgData, LeaveOrgData, User } from '../../models/user'
import { CreateUser } from '../../models/create-user'

class UsersApi {
    getUser(userId: number, orgId: number) {
        return httpClient
            .get(`/users/info?userId=${userId}&orgId=${orgId}`)
            .then(res => {
                const user = res.data as User
                return user
            })
    }

    getUsersByOrgId(orgId: number) {
        return httpClient
            .get(`/users/GetAllByOrgId/${orgId}`)
            .then(res => {
                const users = res.data as User[]
                return users
            })
    }

    getAllUsers(page: number, count: number, sortBy: string = 'email', sortDesc: boolean = false, search: string = '') {
        return httpClient.get('/users', {
            params: {
                page,
                count,
                sortBy,
                sortDir: sortDesc ? 'desc' : 'asc',
                search
            }
        }).then(res => {
            return {
                users: res.data.users as User[],
                totalUsers: res.data.totalUsers as number
            }
        })
    }

    getAllUsersCount() {
        return httpClient.get(`/users/count`)
            .then(res => {
                const count = res.data as number
                return count
            })
    }

    getAvatar(userId: number) {
        return httpClient
            .get(`/users/getAvatar/${userId}`)
            .then(res => {
                const avatar = res.data.result as string
                return avatar
            }).catch(e => {
                return ''
            })
    }

    deleteUser(id: number) {
        return httpClient.post(`/users/delete`, { Id: id } )
    }

    deleteAllUsers() {
        return httpClient.delete(`/users`)
    }

    createUser(user: CreateUser) {
        return httpClient.post(`/users/create`, user)
    }

    updateUser(user: User) {
        return httpClient.post(`/users/update`, user)
    }

    renameUser(user: User) {
        return httpClient.post(`/users/renameUser/?userId=${user.id}`, user)
    }

    updateEmail(user: User) {
        return httpClient.post(`/users/updateEmail/?userId=${user.id}`, user)
    }

    joinOrg(data: JoinOrgData) {
        return httpClient.post(`/users/joinOrg`, data)
    }

    leaveOrg(data: LeaveOrgData) {
        return httpClient.post(`/users/leaveOrg`, data)
    }
}

export const usersApi = new UsersApi()
